import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "watchlist" };
const _hoisted_2 = {
    key: 1,
    class: "data-item data-item--condensed"
};
const _hoisted_3 = { class: "data-item__header" };
const _hoisted_4 = { class: "data-item__nav" };
const _hoisted_5 = { class: "data-item__topic" };
const _hoisted_6 = { class: "data-item__title" };
const _hoisted_7 = {
    key: 0,
    class: "data-item__meta"
};
const _hoisted_8 = { class: "data-item__actions" };
const _hoisted_9 = ["title"];
const _hoisted_10 = { class: "data-item__content" };
const _hoisted_11 = {
    key: 0,
    class: "watchlist__empty"
};
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { key: 2 };
const _hoisted_14 = {
    key: 1,
    class: "watchlist__more"
};
import { onMounted, onUnmounted, ref, computed } from 'vue';
import customers from '@astina/paloma-shop-common-ui/src/services/CustomerRepository';
import env from '../services/AppEnv';
import events from '@astina/paloma-common-ui/src/services/EventBus';
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import CurrentlyUnavailable from "../components/CurrentlyUnavailable.vue";
import WatchlistItem from "../components/WatchlistItem.vue";
import AppDropdown from "@astina/paloma-common-ui/src/components/AppDropdown.vue";
import DeleteWatchlist from "../commands/DeleteWatchlist";
import { saveWatchlist as saveWatchlistUpstream } from "../commands/SaveWatchlist";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import ModalForm from "@astina/paloma-common-ui/src/components/ModalForm.vue";
import AddWatchlistItemsToCart from "../commands/AddWatchlistItemsToCart";
import ExportWatchlist from "../commands/ExportWatchlist";
import sidebarContext from '../services/AppSidebarContext';
import WatchlistUtils from "../services/WatchlistUtils";
import WatchlistShare from "./WatchlistShare.vue";
import config from "../services/PortalConfig";
export default /*@__PURE__*/ _defineComponent({
    __name: 'WatchlistSidebar',
    setup(__props) {
        const watchlist = ref(null);
        const watchlistItems = ref(null);
        const unavailable = ref(false);
        const addToCart = ref(null);
        const exportWatchlist = ref(null);
        const showEditModalForm = ref(false);
        const editForm = ref(null);
        const editFormValidation = ref({ errors: [], fields: {} });
        const sharingEnabled = ref(config.watchlistsSharingEnabled);
        const sharingIcon = ref(config.watchlistsSharingIcon);
        const catalogViewV1 = ref(config.catalog.defaultView === 'v1');
        const watchlistDraft = ref(null);
        const showShareModalForm = ref(false);
        const deleteWatchlist = ref(null);
        const itemLimit = ref(config.watchlistsItemPageSize);
        const moreItems = computed(() => {
            return !!(watchlist.value &&
                (watchlist.value.itemCount || 0) > watchlist.value.itemOffset + itemLimit.value);
        });
        onMounted(() => {
            reloadActiveWatchlist();
            customers.getWatchlistEditForm().then(form => editForm.value = form);
            events.$on('command.activate_watchlist.success', reloadActiveWatchlist);
            events.$on('command.delete_watchlist.success', onWatchlistDelete);
            events.$on('command.add_watchlist_items.success', onItemsAdded);
        });
        onUnmounted(() => {
            events.$off('command.activate_watchlist.success', reloadActiveWatchlist);
            events.$off('command.delete_watchlist.success', onWatchlistDelete);
            events.$off('command.add_watchlist_items.success', onItemsAdded);
        });
        function saveWatchlist() {
            if (!watchlistDraft.value) {
                return;
            }
            saveWatchlistUpstream(watchlistDraft.value)
                .then(watchlistParam => {
                watchlist.value.name = watchlistParam.name;
                showEditModalForm.value = false;
            })
                .catch(validation => editFormValidation.value = validation);
        }
        function close() {
            sidebarContext.closeWatchlistSidebar();
        }
        function permitted(...operation) {
            return WatchlistUtils.permitted(watchlist.value, operation);
        }
        function reloadActiveWatchlist() {
            watchlistItems.value = null;
            loadActiveWatchlist();
        }
        function loadActiveWatchlist() {
            unavailable.value = false;
            const offset = watchlistItems.value === null ? 0 : watchlistItems.value.length;
            env.orders.activeWatchlist && customers.getWatchlist(env.orders.activeWatchlist, offset, itemLimit.value)
                .then(data => {
                onLoad(data);
            })
                .catch(() => {
                watchlist.value = null;
                unavailable.value = true;
            });
        }
        function onLoad(watchlistParam) {
            watchlist.value = watchlistParam;
            if (watchlistItems.value === null) {
                watchlistItems.value = watchlistParam.items;
            }
            else {
                watchlistParam.items.forEach(item => {
                    // remove existing item
                    const existingItem = watchlistItems.value.find(i => i.id === item.id);
                    if (existingItem) {
                        watchlistItems.value.splice(watchlistItems.value.indexOf(existingItem), 1);
                    }
                    watchlistItems.value.push(item);
                });
            }
            addToCart.value = new AddWatchlistItemsToCart(watchlist.value.watchlistId);
            exportWatchlist.value = permitted('doExport')
                ? new ExportWatchlist(watchlist.value.watchlistId) : null;
            deleteWatchlist.value = permitted('delete')
                ? new DeleteWatchlist(watchlist.value.watchlistId) : null;
            watchlistDraft.value = { name: watchlist.value.name, watchlistId: watchlist.value.watchlistId, type: 'manual' };
            showShareModalForm.value = sharingEnabled.value
                && (!!sidebarContext.sidebarParams.openWatchlistShareSettings || showShareModalForm.value);
        }
        function onWatchlistDelete(watchlistId) {
            if (watchlist.value && watchlistId === watchlist.value.watchlistId) {
                watchlist.value = null;
            }
        }
        function onItemsAdded(result) {
            if (watchlist.value && result.watchlist.watchlistId === watchlist.value.watchlistId) {
                if (!moreItems.value) {
                    reloadActiveWatchlist();
                }
                watchlist.value = result.watchlist;
            }
        }
        function onItemDeleted(item) {
            const toDelete = watchlistItems.value.find(i => i.id === item.id);
            if (!toDelete) {
                return;
            }
            watchlistItems.value.splice(watchlistItems.value.indexOf(toDelete), 1);
        }
        function onItemQuantityChanged(item) {
            const toUpdate = watchlistItems.value.find(i => i.id === item.id);
            if (!toUpdate) {
                return;
            }
            toUpdate.quantity = item.quantity;
            watchlistItems.value[watchlistItems.value.indexOf(toUpdate)] = toUpdate;
        }
        function loadMoreItems() {
            loadActiveWatchlist();
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            const _component_router_link = _resolveComponent("router-link");
            const _directive_b_tooltip = _resolveDirective("b-tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !watchlist.value && !unavailable.value
                }, null, 8, ["loading"]),
                _cache[20] || (_cache[20] = _createTextVNode()),
                (!watchlist.value && unavailable.value)
                    ? (_openBlock(), _createBlock(CurrentlyUnavailable, { key: 0 }))
                    : _createCommentVNode("", true),
                _cache[21] || (_cache[21] = _createTextVNode()),
                (watchlist.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("a", {
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (close()), ["prevent"])),
                                    class: "data-item__nav-item",
                                    href: ""
                                }, [
                                    _createVNode(_component_icon, { name: "close" })
                                ]),
                                _cache[11] || (_cache[11] = _createTextVNode()),
                                (_ctx.$isGranted('PORTAL_WATCHLISTS_MANAGE') && permitted('rename', 'doExport', 'delete'))
                                    ? (_openBlock(), _createBlock(AppDropdown, {
                                        key: 0,
                                        class: "data-item__nav-item",
                                        "button-style": "link",
                                        position: "left"
                                    }, {
                                        button: _withCtx(() => [
                                            _createVNode(_component_icon, { name: "ellipsis-v" })
                                        ]),
                                        menu: _withCtx(() => [
                                            (permitted('rename'))
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (showEditModalForm.value = true), ["prevent"])),
                                                    class: "dropdown__item",
                                                    href: ""
                                                }, [
                                                    _createVNode(_component_icon, { name: "pencil" }),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('watchlist.rename')), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _cache[7] || (_cache[7] = _createTextVNode()),
                                            (sharingEnabled.value && permitted('share') && catalogViewV1.value)
                                                ? (_openBlock(), _createBlock(_component_router_link, {
                                                    key: 1,
                                                    to: { name: 'catalog', query: { watchlist: watchlist.value.watchlistId } },
                                                    class: "dropdown__item"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_icon, { name: "eye" }),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('watchlist.show_in_catalog')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["to"]))
                                                : _createCommentVNode("", true),
                                            _cache[8] || (_cache[8] = _createTextVNode()),
                                            (exportWatchlist.value)
                                                ? (_openBlock(), _createBlock(CommandButton, {
                                                    key: 2,
                                                    command: exportWatchlist.value,
                                                    class: "dropdown__item",
                                                    classes: ['button', 'button--link']
                                                }, null, 8, ["command"]))
                                                : _createCommentVNode("", true),
                                            _cache[9] || (_cache[9] = _createTextVNode()),
                                            (deleteWatchlist.value)
                                                ? (_openBlock(), _createBlock(CommandButton, {
                                                    key: 3,
                                                    command: deleteWatchlist.value,
                                                    class: "dropdown__item",
                                                    classes: ['button', 'button--link']
                                                }, null, 8, ["command"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[13] || (_cache[13] = _createTextVNode()),
                            _createElementVNode("h3", _hoisted_5, [
                                _createTextVNode(_toDisplayString(_ctx.$t('watchlist')) + " ", 1),
                                (watchlist.value.type === 'auto')
                                    ? _withDirectives((_openBlock(), _createBlock(_component_icon, {
                                        key: 0,
                                        name: "sparkles",
                                        title: _ctx.$t('watchlist.auto_info')
                                    }, null, 8, ["title"])), [
                                        [
                                            _directive_b_tooltip,
                                            void 0,
                                            void 0,
                                            {
                                                hover: true,
                                                bottom: true
                                            }
                                        ]
                                    ])
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[14] || (_cache[14] = _createTextVNode()),
                            _createElementVNode("h2", _hoisted_6, _toDisplayString(watchlist.value.name), 1),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            (watchlist.value.itemCount && watchlist.value.itemCount > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        (addToCart.value)
                                            ? (_openBlock(), _createBlock(CommandButton, {
                                                key: 0,
                                                command: addToCart.value,
                                                classes: ['button']
                                            }, null, 8, ["command"]))
                                            : _createCommentVNode("", true),
                                        _cache[12] || (_cache[12] = _createTextVNode()),
                                        (sharingEnabled.value && permitted('share'))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (showShareModalForm.value = true), ["prevent"])),
                                                class: "button button--outline",
                                                href: "",
                                                title: _ctx.$t('watchlist.share')
                                            }, [
                                                _createVNode(_component_icon, { name: sharingIcon.value }, null, 8, ["name"]),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('watchlist.share')), 1)
                                            ], 8, _hoisted_9))
                                            : (catalogViewV1.value)
                                                ? (_openBlock(), _createBlock(_component_router_link, {
                                                    key: 2,
                                                    to: { name: 'catalog', query: { watchlist: watchlist.value.watchlistId } },
                                                    class: "button button--outline",
                                                    title: _ctx.$t('watchlist.show_in_catalog')
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_icon, { name: "eye" }),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('watchlist.show_in_catalog')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["to", "title"]))
                                                : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[19] || (_cache[19] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_10, [
                            (watchlist.value.itemCount === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    (permitted('addRemoveItems') && _ctx.$route.name && _ctx.$route.name.toString().indexOf('catalog') === 0)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('watchlist.instructions')) + " ", 1),
                                            _createVNode(_component_icon, { name: "watchlist" })
                                        ]))
                                        : (permitted('addRemoveItems'))
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createElementVNode("p", null, _toDisplayString(_ctx.$t('watchlist.empty')), 1),
                                                _cache[16] || (_cache[16] = _createTextVNode()),
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'catalog' },
                                                    class: "button button--outline"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('catalog.go')), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ], 64))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('watchlist.empty_auto')), 1))
                                ]))
                                : _createCommentVNode("", true),
                            _cache[17] || (_cache[17] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(watchlistItems.value, (item) => {
                                return (_openBlock(), _createBlock(WatchlistItem, {
                                    item: item,
                                    watchlist: watchlist.value,
                                    key: item.id,
                                    onDelete: onItemDeleted,
                                    onQuantityChanged: onItemQuantityChanged
                                }, null, 8, ["item", "watchlist"]));
                            }), 128)),
                            _cache[18] || (_cache[18] = _createTextVNode()),
                            (moreItems.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("a", {
                                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (loadMoreItems()), ["prevent"])),
                                        href: ""
                                    }, _toDisplayString(_ctx.$t('watchlist.show_more_items')), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _cache[22] || (_cache[22] = _createTextVNode()),
                (showEditModalForm.value && editForm.value && watchlistDraft.value)
                    ? (_openBlock(), _createBlock(ModalForm, {
                        key: 2,
                        onSubmit: _cache[4] || (_cache[4] = ($event) => (saveWatchlist())),
                        onCancel: _cache[5] || (_cache[5] = ($event) => (showEditModalForm.value = false)),
                        form: editForm.value,
                        data: watchlistDraft.value,
                        validation: editFormValidation.value,
                        title: _ctx.$t('watchlist.rename'),
                        "modal-size": "medium"
                    }, null, 8, ["form", "data", "validation", "title"]))
                    : _createCommentVNode("", true),
                _cache[23] || (_cache[23] = _createTextVNode()),
                (sharingEnabled.value && showShareModalForm.value && watchlist.value)
                    ? (_openBlock(), _createBlock(WatchlistShare, {
                        key: 3,
                        watchlist: watchlist.value,
                        onCancel: _cache[6] || (_cache[6] = ($event) => (showShareModalForm.value = false)),
                        onSave: reloadActiveWatchlist
                    }, null, 8, ["watchlist"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
